import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import ActionButton from "@/components/Button/ActionButton";
import { HStack } from "@/components/Layout";
import { ProductLogoMediumBusinessOperationEvents } from "@/components/Logo";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { defaultNS, useTranslation } from "@/lib/i18n";

import { StartOperationEventDialog } from "./_list/-components/StartOperationEventDialog";

export const Route = createFileRoute("/_staff/business-operation-events/_list")(
  {
    component: OperationEventsLayout,
  },
);

function OperationEventsLayout() {
  const { t: tSidebar } = useTranslation(defaultNS, {
    keyPrefix: "component.sidebar",
  });
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.operationEvents.list",
  });
  const title = tSidebar("businessEvent");
  useDocumentTitle(title);

  const [startEventDialogOpen, setStartEventDialogOpen] = useState(false);

  const tabs = [
    {
      to: "/business-operation-events/overview",
      children: t("tabs.overview"),
      disabled: true,
    },
    {
      to: "/business-operation-events",
      children: t("tabs.events"),
      activeOptions: { exact: true },
    },
    {
      to: "/business-operation-events/archive",
      children: t("tabs.archive"),
      disabled: true,
    },
    {
      to: "/business-operation-events/operation-activity",
      children: t("tabs.operationActivity"),
      disabled: true,
    },
    {
      to: "/business-operation-events/rule-and-policy",
      children: t("tabs.ruleAndPolicy"),
      disabled: true,
    },
    {
      to: "/business-operation-events/config",
      children: t("tabs.config"),
      disabled: true,
    },
    {
      to: "/business-operation-events/settings",
      children: t("tabs.settings"),
      disabled: true,
    },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={ProductLogoMediumBusinessOperationEvents}
        name={title}
        tabs={tabs}
        type="resource"
      >
        <HStack className="gap-2">
          <ActionButton
            icon="PlusIcon"
            variant="outline"
            onClick={() => setStartEventDialogOpen(true)}
          >
            {t("startNew")}
          </ActionButton>
        </HStack>
      </ProductHeader>
      <Outlet />
      <StartOperationEventDialog
        isOpen={startEventDialogOpen}
        onClose={() => setStartEventDialogOpen(false)}
      />
    </div>
  );
}
